import {Injectable} from "@angular/core";
import {defer, Observable} from "rxjs";
import Keycloak, { KeycloakLoginOptions, KeycloakLogoutOptions } from 'keycloak-js';
import {SettingsService} from "@cupoui/core/services/settings.service";

@Injectable({providedIn: 'root'})
export class AuthenticationService {
  constructor(private readonly keycloak: Keycloak, private readonly  settingsService: SettingsService) {
  }

  redirectToLoginPage(login?: string): Observable<void> {
    if (!!login) {
      const loginOptions: KeycloakLoginOptions = {loginHint: login};
      return defer(() => this.keycloak.login(loginOptions));
    }
    return defer(() => this.keycloak.login());
  }

  logout(): Observable<void> {
    return defer(() => {
      const keycloakSettings = this.settingsService.getKeycloakSettings();
      const logoutOptions: KeycloakLogoutOptions =
        keycloakSettings?.postLogoutRedirectUri
          ? { logoutMethod: 'GET' as const, redirectUri: keycloakSettings.postLogoutRedirectUri }
          : { logoutMethod: 'GET' as const, redirectUri: 'https://www.sos.eu' };
      return this.keycloak.logout(logoutOptions);
    });
  }
}
